// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1QCVh","list":"styles_list__3Lhdv"};